define([
    "dojo/dom-class",
    "dojo/on",
    "dojo/query",
    "dojo/touch"
], function (domClass, on, query, touch) {

    var isBlocked;
    var releaseConnection;
    var blockedIframes;
    var body;

    return {
        /**
         * Prevents drag selection at the document level until the next mouse/touch release.
         * Also prevents iframes or objects in the page from stealing pointer events.
         */
        blockUntilRelease: function (node) {
            if (releaseConnection) {
                return;  // Selection is already blocked pending release
            }

            this.blockSelection(node);
            this._blockIframePointerEvents();
            var that = this;
            releaseConnection = on(window, touch.release, function () {
                that.unblockSelection(node);
                that._unblockIframePointerEvents(node.ownerDocument.body);
                releaseConnection = null;
            });

        },

        blockSelection: function (node) {
            if (!isBlocked) {
                body = node.ownerDocument.body;
                domClass.add(body, "noselect");
                isBlocked = true;
            }
        },

        unblockSelection: function() {
            if (isBlocked) {
                domClass.remove(body, "noselect");
                isBlocked = false;
            }
        },

        _blockIframePointerEvents: function(bodyNode) {
            blockedIframes = query("iframe, object", bodyNode);
            blockedIframes.forEach(function(iframe) {
                domClass.add(iframe, "nopointer");
            });
        },

        _unblockIframePointerEvents: function() {
            if (blockedIframes) {
                blockedIframes.forEach(function(iframe) {
                    domClass.remove(iframe, "nopointer");
                });
                blockedIframes = null;
            }
        }
    };
});